
    <div #container
      class="IconContainer"
      [attr.data-color]="color"
      [attr.data-hover-color]="hoverColor"
      [attr.data-size]="size"
      [attr.data-size-tablet]="sizeTablet"
      [attr.data-size-desktop]="sizeDesktop"
      [attr.data-legacy]="attrLegacy"
      [attr.aria-label]="label"
      [attr.title]="label"
      [attr.aria-hidden]="!attrAriaHidden"
    ></div>
  